import { fetchProjects } from '@/api/projects';
import type { ProjectsQuery } from '@/api/projects';
import type { ProjectListItem } from '@/api/types';

const PAGE_SIZE = 100;

// 필터 조건(q·stage)에 맞는 게임을 모든 페이지에 걸쳐 한 번에 받는다.
// 권한 추가 목록은 이 결과를 클라이언트에서 페이지네이션한다 — 보유 권한으로 넣고 뺄 때
// 건수·페이지가 즉시 맞도록. 중간 실패는 부분 결과 없이 에러로 끝낸다.
export async function fetchAllProjects(query: ProjectsQuery, signal: AbortSignal): Promise<ProjectListItem[]> {
  const games = new Map<string, ProjectListItem>();
  let received = 0;
  for (let page = 1; ; page += 1) {
    const response = await fetchProjects({ ...query, page, page_size: PAGE_SIZE }, signal);
    for (const game of response.projects) {
      games.set(game.project_id ?? `prefix:${game.prefix}`, game);
    }
    received += response.projects.length;
    if (received >= response.total) break;
    if (!response.projects.length) throw new Error('게임 목록이 변경되었습니다. 다시 선택해 주세요.');
  }
  return [...games.values()];
}
